import { createSelector, createFeatureSelector, Store } from '@ngrx/store';
// import * as fromRoot from '../../../../reducers';
import * as fromList from './list';
import * as fromLocation from './location';

export interface LocationState {
  locationList: fromList.State;
  location: fromLocation.State;
}

export interface State {
  // extends fromRoot.State {
  location: LocationState;
}

export const reducers = {
  locationList: fromList.reducer,
  location: fromLocation.reducer,
};

export const selectLocationState = createFeatureSelector<LocationState>(
  'locations'
);

export const selectLocations = createSelector(
  selectLocationState,
  (state: LocationState) => state.locationList
);
export const selectLocation = createSelector(
  selectLocationState,
  (state: LocationState) => state.location
);

export const getLocationsFilter = createSelector(
  selectLocations,
  fromList.getFilter
);

export const getLocationsLoading = createSelector(
  selectLocations,
  fromList.getLoading
);

export const getLocationsLoaded = createSelector(
  selectLocations,
  fromList.getLoaded
);
export const getLocationsList = createSelector(
  selectLocations,
  fromList.getList
);

export const getLocation = createSelector(
  selectLocation,
  fromLocation.getLocation
);

export const gettError = createSelector(selectLocation, fromLocation.getError);

export const getLocationLoading = createSelector(
  selectLocation,
  fromLocation.getLoading
);

export const getLocationLoaded = createSelector(
  selectLocation,
  fromLocation.getLoaded
);
